<template>
  <div class="">
    <page-header title="New Route" breadcrumb="Dashboard >> Settings >> Routes >> New Route" />

    <div class="mt-3 custom-card">
      <div class=" text-base text-primary-yellow pb-3">{{ isTripBreak ? 'Secondary' : 'Primary' }} Routes</div>

      <div class="route-type">
        <div>
          <p class="font-semibold">Route Type</p>
        </div>
        <div class="route-type-opt">
          <div>
            <label for="inter-state" class="radio-label label">
              <input type="radio" id="inter-state" value="interState" v-model="routeType" />
              Inter State
              <span></span>
            </label>
          </div>
          
          <!-- <div class="single-option">
            <label for="intra-state" class="radio-label label">
              <input type="radio" id="intra-state" value="intraState" v-model="routeType" />
              Intra State
              <span></span>
            </label>
          </div> -->
         
          <div v-if="$store.state.authentication.env == 'development'" class=" ml-4">
            <label for="international" class="radio-label label">
              <input disabled type="radio" id="international" value="international" v-model="routeType" />
              International
              <span></span>
            </label>
          </div>
        </div>
      </div>

      <inter-state-form v-if="isInterstate" :states="states" :setTripBreak="setTripBreak"/>
      <intra-state-form v-if="isIntrastate" :states="states" />
      <international v-if="international" :states="states"/>
    </div>
  </div>
</template>

<script>
import InterStateForm from "./partials/InterStateForm.vue";
import IntraStateForm from "./partials/IntraStateForm.vue";
import International from "./partials/International.vue"

export default {
  components: {
    InterStateForm,
    International,
    IntraStateForm
  },
  data() {
    return {
      routeType: "interState",
      isTripBreak: false
    };
  },
  mounted() {
    this.getAllStatesAndCities();
  },
  methods: {
   setTripBreak(val){
       this.isTripBreak = val
   },
    createRequestPayload() { },
  },
  computed: {
    isInterstate() {
      return this.routeType === "interState";
    },
    isIntrastate() {
      return this.routeType === "intraState";
    },
    international() {
      return this.routeType === "international";
    },
  },
  watch: {},
};
</script>
<style lang="scss" scoped>
.route-type {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  p {
    padding-right: 2rem;
  }
}

.route-type-opt {
  display: flex;
  flex-wrap: wrap;
  margin-top: 0.7rem;
}
</style>
